import VueCookies from 'vue-cookies'
import Vue from 'vue'
import getEnv from '../utils/env'

Vue.use(VueCookies)
Vue.$cookies.config('1d', '', '', getEnv('VUE_APP_BACKEND_SECURE') === 'true')

const ID_TOKEN_KEY = 'C_ID'

const isDev = () => getEnv('NODE_ENV') === 'development'
const domainUrl = () => getEnv('VUE_APP_DOMAIN_NAME')

export const getToken = () => {
  return Vue.$cookies.get(ID_TOKEN_KEY)
}

export const saveToken = (token) => {
  if (token) {
    Vue.$cookies.set(ID_TOKEN_KEY, token, '1d', '/')
  }
}

export const destroyToken = () => {
  Vue.$cookies.remove(ID_TOKEN_KEY, '/')
}

export default { getToken, saveToken, destroyToken }
